<template>
  <div>
    <div class="p-lg-3">
      <div class="row justify-content-between">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">
          Produtos/Serviços
        </h3>
      </div>
    </div>
    <div class="p-lg-3">
      <div class="row justify-content-between">
        <!-- DIALOG DE CADASTRO -->
        <v-dialog
          v-model="dialogCadastro"
          max-width="500px"
          persistent
          fullscreen
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="allowCadastrarBtn"
              color="#1daf80"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              Novo Produto Serviço
            </v-btn>
          </template>
          <v-card>
            <v-toolbar style="background-color: #1daf80; color: #fff">
              <v-btn icon dark @click="dialogCadastro = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                <span class="headline">Cadastrar Produto Serviço</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items> </v-toolbar-items>
            </v-toolbar>
            <nova-loja
              v-if="dialogCadastro"
              @close="dialogCadastro = false"
              @response="getListaProdutosServicos"
            />
          </v-card>
        </v-dialog>
      </div>
    </div>

    <!-- <v-data-table
      v-on:update:sort-by="options.ordenacao = false"
      :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
      :search="search"
      :headers="headers"
      :items="lojas"
      :options.sync="options"
      :server-items-length="totalList"
      class="elevation-1"
      :loading="loading"
      :loading-text="'Carregando...'"
    > -->
    <v-data-table
      :headers="headers"
      :items="produtos"
      class="elevation-1"
      :loading="loading"
      v-on:update:sort-by="options.ordenacao = false"
      :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
      :loading-text="'Carregando...'"
    >
      <template v-slot:top v-if="false">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          :class="item.id_status == 1 ? 'btn-ativo' : 'btn-inativo'"
          :title="item.id_status == 1 ? 'Desativar' : 'Ativar'"
          @click="editStatusItem(item.id_produto, item.id_status)"
        >
          fas fa-toggle-on
        </v-icon>
        <!-- <v-icon
          v-if="allowEditarBtn"
          small
          class="mr-2"
          @click="editItem(item.loja_id)"
        >
          fas fa-edit
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <p class="text-center">Nenhum registro encontrado</p>
        <v-btn color="#1daf80" dark @click="getListaProdutosServicos">
          Atualizar
        </v-btn>
      </template>
    </v-data-table>
    <!-- DIALOG DE EDIÇÃO -->
    <v-dialog
      v-model="dialogEdicao"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar style="background-color: #1daf80; color: #fff">
          <v-btn icon dark @click="dialogEdicao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span class="headline">Editar Produto Serviço</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <edicao-loja
          v-if="dialogEdicao"
          :visualizar="prodServ_id"
          :key="render"
          @close="dialogEdicao = false"
          @response="getListaProdutosServicos"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EdicaoLoja from "@/components/produtos-servicos/edicao_prod_serv.vue";
import NovaLoja from "@/components/produtos-servicos/nova_prod_serv.vue";
import Mixin from "@/mixins/vuex_mixin.js";
import UnidadeService from "../services/unidade_service";
import ProdutosServicosService from "../services/produtos_servicos_service";
import AuthService from "../services/auth_service";
// import endpoints from "../router/endpoints";

export default {
  mixins: [Mixin],
  components: {
    EdicaoLoja,
    NovaLoja,
  },

  data: () => ({
    render: 0,
    dialogCadastro: false,
    dialogEdicao: false,
    loading: false,
    search: "",
    totalList: 10,
    options: {
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      ordenacao: false,
      desc: false,
    },
    produtos: [],
    headers: [
      {
        text: "Produto",
        align: "start",
        sortable: false,
        value: "nome_produto",
      },
      { text: "Valor", value: "valor_produto_formatado", sortable: false },
      { text: "Unidade", value: "desc_unidade", sortable: false },
      // { text: "Loja", value: "id_loja", sortable: false },
      { text: "Tipo", value: "desc_tipo", sortable: false },
      { text: "Status", value: "desc_status", sortable: false },
      { text: "Ações", align: "end", value: "actions", sortable: false },
    ],
    services: {
      unidadeService: UnidadeService.build(),
      prodServService: ProdutosServicosService.build(),
      authService: AuthService.build(),
    },
  }),

  computed: {
    allowCadastrarBtn() {
      return true;
      // return this.services.authService.temPermissao(
      //   endpoints["UnidadeController::POST->register"]
      // );
    },
    allowEditarBtn() {
      return true;
      // return this.services.authService.temPermissao(
      //   endpoints["UnidadeController::POST->updateUnidadeData/$1"]
      // );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.options.desc = this.options.sortDesc[0] ?? false;
        this.getListaProdutosServicos();
      },
      deep: true,
    },
    search(value, oldValue) {
      if (value.length > 2) {
        this.options.page = 1;
        this.getListaProdutosServicos();
      }
      if (value.length == 0 && oldValue.length > 0) {
        this.options.page = 1;
        this.getListaProdutosServicos();
      }
    },
  },

  mounted() {
    this.getListaProdutosServicos();
  },

  methods: {
    forceRender() {
      this.render += 1;
    },
    getListaProdutosServicos() {
      this.loading = true;
      this.produtos = [];
      this.services.prodServService
        .getProdutosServicos()
        // .getUnidadePaginatedList({
        //   page: this.options.page,
        //   per_page: this.options.itemsPerPage,
        //   search: this.search,
        //   order: this.options.ordenacao,
        //   desc: this.options.desc,
        // })
        .then(async (response) => {
          if (response.status !== 200) return;
          const { data } = await response.json();
          // const { lojas, pagination } = data;
          // this.totalList = pagination.num_rows;
          const { produtos } = data;
          this.produtos = [];
          this.totalList = produtos.length;
          for (let index = 0; index < this.totalList; index++) {
            const element = produtos[index];
            this.produtos.push({
              id_produto: element.id,
              nome_produto: element.nome,
              desc_produto: element.descricao,
              valor_produto: element.valor,
              valor_produto_formatado: parseFloat(element.valor).toLocaleString(
                "pt-br",
                {
                  style: "currency",
                  currency: "BRL",
                }
              ),
              id_unidade: element.id_unidade,
              desc_unidade: element.nome_fantasia,
              id_loja: element.id_loja,
              id_status: element.id_status,
              desc_status: element.produto_status,
              id_tipo: element.id_tipo,
              nome_tipo: element.tipo_nome,
              desc_tipo: element.tipo_descricao,
            });
          }
        })
        .catch((error) => {
          console.error({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editItem(id) {
      this.prodServId = id;
      this.render = 1;
      this.dialogEdicao = true;
    },

    editStatusItem(id_Prod, id_status) {
      this.services.prodServService.postUpdateStatusProdutosServicos(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.$_ACTIONS_showSnackbarMessage({
                message:
                  body.message || this.$global.messages.internalServerError,
                color: "sucess",
              });
            } else {
              this.$_ACTIONS_showSnackbarMessage({
                message:
                  body.message || this.$global.messages.internalServerError,
                color: "error",
              });
            }
          },
          onError: (message) => {
            this.$_ACTIONS_showSnackbarMessage({
              message: message || this.$global.messages.internalServerError,
              color: "error",
            });
          },
          onEnd: () => {
            this.getListaProdutosServicos();
          },
        },
        {
          id: parseInt(id_Prod),
          id_status: id_status == 2 ? 1 : 2,
        }
      );
    },
    close() {
      this.dialogCadastro = false;
      this.dialogEdicao = false;
      this.getListaProdutosServicos();
    },
  },
};
</script>
<style>
.btn-ativo {
  color: #1a8c1a !important;
}
.btn-inativo {
  color: #ae1111 !important;
  transform: rotate(180deg);
}
</style>
